import { msg } from "@lingui/core/macro";
import { graphql } from "gql.tada";

/** Shared customer support contact for product UI notices. */
export const SUPPORT_EMAIL = "amethyst-support@ja.dev";

export type UserOrganizationRole = ReturnType<
  typeof graphql.scalar<"UserOrganizationRole">
>;

/**
 * User-facing role labels.
 *
 * `RESTRICTED_MEMBER` is intentionally collapsed into `Editor` so role lists
 * and summaries stay aligned with the four labels shown in the UI.
 * Translate these descriptors at the point of use with `i18n._()`.
 */
export const UserOrganizationRoleLabels = {
  OWNER: msg`Owner`,
  ADMINISTRATOR: msg`Administrator`,
  FULL_MEMBER: msg`Editor`,
  RESTRICTED_MEMBER: msg`Editor`,
  GUEST: msg`Viewer`,
} as const satisfies Record<UserOrganizationRole, ReturnType<typeof msg>>;
